import React, { SetStateAction } from "react";
import { TextField, Typography } from "@mui/material";
import { FormField } from "generated/graphql";
import Flex from "components/Flex";
import DebouncedText from "components/DebouncedText";
import update, { Spec } from "immutability-helper";
import PCheckbox from "components/PCheckbox";
import theme from "theme";

export interface FormFieldBuilderProps {
  lensRuleDescriptions: string[];
  state: FormField;
  setState: React.Dispatch<SetStateAction<FormField>>;
}

const FormFieldBuilder = (props: FormFieldBuilderProps) => {
  const { state, setState } = props;

  const [showJSON] = React.useState(false);

  const doUpdate = (spec: Spec<FormField>) => setState((prev) => update(prev, spec));

  const textFieldProps = (width: number) => ({
    style: {
      width: width,
    },
  });

  return (
    <Flex
      sx={{
        flexDirection: "column",
        padding: theme.spacing(1),
        margin: theme.spacing(1),
      }}>
      <Flex flexDirection="row">
        <TextField variant="filled" disabled label="DB Field ID" value={state.id} />
        <DebouncedText
          textFieldProps={textFieldProps(300)}
          label="Name"
          value={state.name}
          onChange={(value) => doUpdate({ name: { $set: value } })}
        />
        <DebouncedText
          textFieldProps={textFieldProps(500)}
          label="Prompt"
          value={state.prompt}
          onChange={(value) => doUpdate({ prompt: { $set: value } })}
        />
      </Flex>
      <Flex
        sx={{
          padding: theme.spacing(1),
          backgroundColor: "white",
          // borderRadius: "4px",
          borderBottomStyle: "solid",
          borderBottomWidth: "0.5px",
          borderBottomColor: "#333333",
        }}
        flexDirection="row">
        <PCheckbox
          // formClassName={classes.formCheckbox}
          label="Prompt Yes/No"
          checked={state.promptYesNo}
          onChange={(evt) => doUpdate({ promptYesNo: { $set: evt.target.checked } })}
        />
        <PCheckbox
          // formClassName={classes.formCheckbox}
          label="Repeating"
          checked={state.repeating}
          onChange={(evt) => doUpdate({ repeating: { $set: evt.target.checked } })}
        />
        <PCheckbox
          // formClassName={classes.formCheckbox}
          label="Required"
          checked={state.required}
          onChange={(evt) => doUpdate({ required: { $set: evt.target.checked } })}
        />
      </Flex>
      <Flex>
        {showJSON && state.cells.map((cell, idx) => <Typography key={idx}>{JSON.stringify(cell)}</Typography>)}
      </Flex>
    </Flex>
  );
};

export default FormFieldBuilder;
